import React from 'react';
import { isSameDay } from 'date-fns';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { SingleDayCalendarPicker } from './SingleDayCalendarPicker';
import { toLocalDateString } from '../utils/payrollPeriodLocal';

export interface DayNavigatorProps {
  day: Date;
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  onPreviousDay: () => void;
  onNextDay: () => void;
  onToday: () => void;
  onDaySelect: (ymd: string) => void;
  disabled?: boolean;
  className?: string;
}

export function DayNavigator({
  day,
  weekStartsOn,
  onPreviousDay,
  onNextDay,
  onToday,
  onDaySelect,
  disabled = false,
  className = '',
}: DayNavigatorProps) {
  const isToday = isSameDay(day, new Date());

  return (
    <div className={`flex items-center flex-wrap gap-3 ${className}`}>
      <button
        type="button"
        onClick={onPreviousDay}
        disabled={disabled}
        className="p-2 border rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Previous day"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>

      <SingleDayCalendarPicker
        value={toLocalDateString(day)}
        onChange={onDaySelect}
        weekStartsOn={weekStartsOn}
        disabled={disabled}
        aria-label="Select day"
        buttonClassName="min-w-[220px] px-4 py-2 text-lg font-medium border-gray-300 rounded-lg"
      />

      <button
        type="button"
        onClick={onNextDay}
        disabled={disabled}
        className="p-2 border rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Next day"
      >
        <ChevronRight className="h-4 w-4" />
      </button>

      <button
        type="button"
        onClick={onToday}
        disabled={disabled || isToday}
        className="px-4 py-2 text-sm border rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Today
      </button>
    </div>
  );
}
